import * as React from 'react';
import { useTranslation } from 'react-i18next';

import Breadcrumbs from './Breadcrumbs';
import { Box } from './generic/box/box';
import BackButton from './generic/nav-button/BackButton';
import * as styles from './PageNav.style';

import type { Crumb } from './Breadcrumbs';

interface Props {
  crumbs: Crumb[];
  // Where to go when there is no in-app history to return to.
  fallbackTo: string;
}

// Every page below the front page carries both: the back button returns to
// wherever the reader came from, the trail says where they are in the hierarchy.
const PageNav = ({ crumbs, fallbackTo }: Props): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Box style={styles.row} className="kb-page-nav">
      <BackButton fallbackTo={fallbackTo} style={{ marginBottom: 0 }}>
        {t('go_back')}
      </BackButton>
      <Breadcrumbs crumbs={crumbs} style={{ marginBottom: 0 }} />
    </Box>
  );
};

export default PageNav;
